import { render, staticRenderFns } from "./RealData.vue?vue&type=template&id=85c7df86&scoped=true&"
import script from "./RealData.vue?vue&type=script&lang=js&"
export * from "./RealData.vue?vue&type=script&lang=js&"
import style0 from "./RealData.vue?vue&type=style&index=0&id=85c7df86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c7df86",
  null
  
)

export default component.exports